const share = (to, subject, body) => {
  window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
};

export default { share };
